module.exports = __webpack_public_path__ + "static/media/eye.f5bf269d.svg";